import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { map, tap } from 'rxjs/operators';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { FormatUtils } from '../../shared/_utils/services/formatUtils';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { SupportingDocument } from '../entities/supportingDocument';

@Injectable()
export class SupportingDocumentService extends BaseCrudService<SupportingDocument> {

    public uri = '/api/supportingDocument/';

    constructor(injector: Injector) {
        super(injector);
       //console.log('Instance SupportingDocumentService');
    }

    buildSentence(entity?: SupportingDocument, event?: LazyLoadEvent): HttpParams {
        this.httpParams = new HttpParams();
        if (entity) {
            let query = entity.code ? 'code'
                + QueryOperator.Contain + entity.code
                + QueryOperator.Split : QueryOperator.Empty;
            query = query.concat(
                entity.name ? 'name'
                + QueryOperator.Contain + entity.name
                + QueryOperator.Split : QueryOperator.Empty
            );
            if (entity.executingUnit && entity.executingUnit.id) {
                query = query.concat(
                  `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
                );
              }
            this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
        }

        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1 ).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }

    getSequenceCode(): Observable<string> {
        const url = this.rutaServidor + this.uri + 'maxCode/';
        return this.httpClient.get<any>(url)
            .pipe(
                map(response => {
                    // debugger;
                    const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 5);
                    const sequence = (parseInt(code, 10)) + 1;
                    return FormatUtils.padLeftZero(sequence, 5);
                }),
                tap(response =>  {
                   //console.log(response);
                })
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/supporting-document.service.ts